module.exports = {
	"version": "2.0",
	"metadata": {
		"apiVersion": "2016-04-18",
		"endpointPrefix": "cognito-idp",
		"jsonVersion": "1.1",
		"protocol": "json",
		"serviceFullName": "Amazon Cognito Identity Provider",
		"signatureVersion": "v4",
		"targetPrefix": "AWSCognitoIdentityProviderService"
	},
	"operations": {
		"AddCustomAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"CustomAttributes"
				],
				"members": {
					"UserPoolId": {},
					"CustomAttributes": {
						"type": "list",
						"member": {
							"shape": "S4"
						}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminConfirmSignUp": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminCreateUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"UserAttributes": {
						"shape": "Sg"
					},
					"ValidationData": {
						"shape": "Sg"
					},
					"TemporaryPassword": {
						"shape": "Sk"
					},
					"ForceAliasCreation": {
						"type": "boolean"
					},
					"MessageAction": {},
					"DesiredDeliveryMediums": {
						"type": "list",
						"member": {}
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"User": {
						"shape": "Sq"
					}
				}
			}
		},
		"AdminDeleteUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			}
		},
		"AdminDeleteUserAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"UserAttributeNames"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"UserAttributeNames": {
						"shape": "Sx"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminDisableUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminEnableUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminForgetDevice": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"DeviceKey"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"DeviceKey": {}
				}
			}
		},
		"AdminGetDevice": {
			"input": {
				"type": "structure",
				"required": [
					"DeviceKey",
					"UserPoolId",
					"Username"
				],
				"members": {
					"DeviceKey": {},
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Device"
				],
				"members": {
					"Device": {
						"shape": "S17"
					}
				}
			}
		},
		"AdminGetUser": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Username"
				],
				"members": {
					"Username": {
						"shape": "Sd"
					},
					"UserAttributes": {
						"shape": "Sg"
					},
					"UserCreateDate": {
						"type": "timestamp"
					},
					"UserLastModifiedDate": {
						"type": "timestamp"
					},
					"Enabled": {
						"type": "boolean"
					},
					"UserStatus": {},
					"MFAOptions": {
						"shape": "St"
					}
				}
			}
		},
		"AdminInitiateAuth": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientId",
					"AuthFlow"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1b"
					},
					"AuthFlow": {},
					"AuthParameters": {
						"shape": "S1d"
					},
					"ClientMetadata": {
						"shape": "S1e"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChallengeName": {},
					"Session": {},
					"ChallengeParameters": {
						"shape": "S1i"
					},
					"AuthenticationResult": {
						"shape": "S1j"
					}
				}
			}
		},
		"AdminListDevices": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"Limit": {
						"type": "integer"
					},
					"PaginationToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Devices": {
						"shape": "S1r"
					},
					"PaginationToken": {}
				}
			}
		},
		"AdminResetUserPassword": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminRespondToAuthChallenge": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientId",
					"ChallengeName"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1b"
					},
					"ChallengeName": {},
					"ChallengeResponses": {
						"shape": "S1v"
					},
					"Session": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChallengeName": {},
					"Session": {},
					"ChallengeParameters": {
						"shape": "S1i"
					},
					"AuthenticationResult": {
						"shape": "S1j"
					}
				}
			}
		},
		"AdminSetUserSettings": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"MFAOptions"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"MFAOptions": {
						"shape": "St"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminUpdateDeviceStatus": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"DeviceKey"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"DeviceKey": {},
					"DeviceRememberedStatus": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminUpdateUserAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username",
					"UserAttributes"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					},
					"UserAttributes": {
						"shape": "Sg"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"AdminUserGlobalSignOut": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"Username"
				],
				"members": {
					"UserPoolId": {},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"ChangePassword": {
			"input": {
				"type": "structure",
				"required": [
					"PreviousPassword",
					"ProposedPassword"
				],
				"members": {
					"PreviousPassword": {
						"shape": "Sk"
					},
					"ProposedPassword": {
						"shape": "Sk"
					},
					"AccessToken": {
						"shape": "S1k"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		},
		"ConfirmDevice": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken",
					"DeviceKey"
				],
				"members": {
					"AccessToken": {
						"shape": "S1k"
					},
					"DeviceKey": {},
					"DeviceSecretVerifierConfig": {
						"type": "structure",
						"members": {
							"PasswordVerifier": {},
							"Salt": {}
						}
					},
					"DeviceName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserConfirmationNecessary": {
						"type": "boolean"
					}
				}
			}
		},
		"ConfirmForgotPassword": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"Username",
					"ConfirmationCode",
					"Password"
				],
				"members": {
					"ClientId": {
						"shape": "S1b"
					},
					"SecretHash": {
						"shape": "S2d"
					},
					"Username": {
						"shape": "Sd"
					},
					"ConfirmationCode": {},
					"Password": {
						"shape": "Sk"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		},
		"ConfirmSignUp": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"Username",
					"ConfirmationCode"
				],
				"members": {
					"ClientId": {
						"shape": "S1b"
					},
					"SecretHash": {
						"shape": "S2d"
					},
					"Username": {
						"shape": "Sd"
					},
					"ConfirmationCode": {},
					"ForceAliasCreation": {
						"type": "boolean"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		},
		"CreateUserImportJob": {
			"input": {
				"type": "structure",
				"required": [
					"JobName",
					"UserPoolId",
					"CloudWatchLogsRoleArn"
				],
				"members": {
					"JobName": {},
					"UserPoolId": {},
					"CloudWatchLogsRoleArn": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserImportJob": {
						"shape": "S2m"
					}
				}
			}
		},
		"CreateUserPool": {
			"input": {
				"type": "structure",
				"required": [
					"PoolName"
				],
				"members": {
					"PoolName": {},
					"Policies": {
						"shape": "S2u"
					},
					"LambdaConfig": {
						"shape": "S2x"
					},
					"AutoVerifiedAttributes": {
						"shape": "S2y"
					},
					"AliasAttributes": {
						"shape": "S30"
					},
					"SmsVerificationMessage": {},
					"EmailVerificationMessage": {},
					"EmailVerificationSubject": {},
					"SmsAuthenticationMessage": {},
					"MfaConfiguration": {},
					"DeviceConfiguration": {
						"shape": "S36"
					},
					"EmailConfiguration": {
						"shape": "S37"
					},
					"SmsConfiguration": {
						"shape": "S39"
					},
					"AdminCreateUserConfig": {
						"shape": "S3a"
					},
					"Schema": {
						"shape": "S3d"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPool": {
						"shape": "S3f"
					}
				}
			}
		},
		"CreateUserPoolClient": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientName"
				],
				"members": {
					"UserPoolId": {},
					"ClientName": {},
					"GenerateSecret": {
						"type": "boolean"
					},
					"RefreshTokenValidity": {
						"type": "integer"
					},
					"ReadAttributes": {
						"shape": "S3l"
					},
					"WriteAttributes": {
						"shape": "S3l"
					},
					"ExplicitAuthFlows": {
						"shape": "S3n"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPoolClient": {
						"shape": "S3q"
					}
				}
			}
		},
		"DeleteUser": {
			"input": {
				"type": "structure",
				"members": {
					"AccessToken": {
						"shape": "S1k"
					}
				}
			},
			"authtype": "none"
		},
		"DeleteUserAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"UserAttributeNames"
				],
				"members": {
					"UserAttributeNames": {
						"shape": "Sx"
					},
					"AccessToken": {
						"shape": "S1k"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		},
		"DeleteUserPool": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {}
				}
			}
		},
		"DeleteUserPoolClient": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientId"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1b"
					}
				}
			}
		},
		"DescribeUserImportJob": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"JobId"
				],
				"members": {
					"UserPoolId": {},
					"JobId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserImportJob": {
						"shape": "S2m"
					}
				}
			}
		},
		"DescribeUserPool": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPool": {
						"shape": "S3f"
					}
				}
			}
		},
		"DescribeUserPoolClient": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientId"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1b"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPoolClient": {
						"shape": "S3q"
					}
				}
			}
		},
		"ForgetDevice": {
			"input": {
				"type": "structure",
				"required": [
					"DeviceKey"
				],
				"members": {
					"AccessToken": {
						"shape": "S1k"
					},
					"DeviceKey": {}
				}
			}
		},
		"ForgotPassword": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"Username"
				],
				"members": {
					"ClientId": {
						"shape": "S1b"
					},
					"SecretHash": {
						"shape": "S2d"
					},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CodeDeliveryDetails": {
						"shape": "S46"
					}
				}
			},
			"authtype": "none"
		},
		"GetCSVHeader": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPoolId": {},
					"CSVHeader": {
						"type": "list",
						"member": {}
					}
				}
			}
		},
		"GetDevice": {
			"input": {
				"type": "structure",
				"required": [
					"DeviceKey"
				],
				"members": {
					"DeviceKey": {},
					"AccessToken": {
						"shape": "S1k"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Device"
				],
				"members": {
					"Device": {
						"shape": "S17"
					}
				}
			}
		},
		"GetUser": {
			"input": {
				"type": "structure",
				"members": {
					"AccessToken": {
						"shape": "S1k"
					}
				}
			},
			"output": {
				"type": "structure",
				"required": [
					"Username",
					"UserAttributes"
				],
				"members": {
					"Username": {
						"shape": "Sd"
					},
					"UserAttributes": {
						"shape": "Sg"
					},
					"MFAOptions": {
						"shape": "St"
					}
				}
			},
			"authtype": "none"
		},
		"GetUserAttributeVerificationCode": {
			"input": {
				"type": "structure",
				"required": [
					"AttributeName"
				],
				"members": {
					"AccessToken": {
						"shape": "S1k"
					},
					"AttributeName": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CodeDeliveryDetails": {
						"shape": "S46"
					}
				}
			},
			"authtype": "none"
		},
		"GlobalSignOut": {
			"input": {
				"type": "structure",
				"members": {
					"AccessToken": {
						"shape": "S1k"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"InitiateAuth": {
			"input": {
				"type": "structure",
				"required": [
					"AuthFlow",
					"ClientId"
				],
				"members": {
					"AuthFlow": {},
					"AuthParameters": {
						"shape": "S1d"
					},
					"ClientMetadata": {
						"shape": "S1e"
					},
					"ClientId": {
						"shape": "S1b"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChallengeName": {},
					"Session": {},
					"ChallengeParameters": {
						"shape": "S1i"
					},
					"AuthenticationResult": {
						"shape": "S1j"
					}
				}
			}
		},
		"ListDevices": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken"
				],
				"members": {
					"AccessToken": {
						"shape": "S1k"
					},
					"Limit": {
						"type": "integer"
					},
					"PaginationToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Devices": {
						"shape": "S1r"
					},
					"PaginationToken": {}
				}
			}
		},
		"ListUserImportJobs": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"MaxResults"
				],
				"members": {
					"UserPoolId": {},
					"MaxResults": {
						"type": "integer"
					},
					"PaginationToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserImportJobs": {
						"type": "list",
						"member": {
							"shape": "S2m"
						}
					},
					"PaginationToken": {}
				}
			}
		},
		"ListUserPoolClients": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"MaxResults": {
						"type": "integer"
					},
					"NextToken": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPoolClients": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"ClientId": {
									"shape": "S1b"
								},
								"UserPoolId": {},
								"ClientName": {}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListUserPools": {
			"input": {
				"type": "structure",
				"required": [
					"MaxResults"
				],
				"members": {
					"NextToken": {},
					"MaxResults": {
						"type": "integer"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPools": {
						"type": "list",
						"member": {
							"type": "structure",
							"members": {
								"Id": {},
								"Name": {},
								"LambdaConfig": {
									"shape": "S2x"
								},
								"Status": {},
								"LastModifiedDate": {
									"type": "timestamp"
								},
								"CreationDate": {
									"type": "timestamp"
								}
							}
						}
					},
					"NextToken": {}
				}
			}
		},
		"ListUsers": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"AttributesToGet": {
						"type": "list",
						"member": {}
					},
					"Limit": {
						"type": "integer"
					},
					"PaginationToken": {},
					"Filter": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"Users": {
						"type": "list",
						"member": {
							"shape": "Sq"
						}
					},
					"PaginationToken": {}
				}
			}
		},
		"ResendConfirmationCode": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"Username"
				],
				"members": {
					"ClientId": {
						"shape": "S1b"
					},
					"SecretHash": {
						"shape": "S2d"
					},
					"Username": {
						"shape": "Sd"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CodeDeliveryDetails": {
						"shape": "S46"
					}
				}
			},
			"authtype": "none"
		},
		"RespondToAuthChallenge": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"ChallengeName"
				],
				"members": {
					"ClientId": {
						"shape": "S1b"
					},
					"ChallengeName": {},
					"Session": {},
					"ChallengeResponses": {
						"shape": "S1v"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"ChallengeName": {},
					"Session": {},
					"ChallengeParameters": {
						"shape": "S1i"
					},
					"AuthenticationResult": {
						"shape": "S1j"
					}
				}
			}
		},
		"SetUserSettings": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken",
					"MFAOptions"
				],
				"members": {
					"AccessToken": {
						"shape": "S1k"
					},
					"MFAOptions": {
						"shape": "St"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		},
		"SignUp": {
			"input": {
				"type": "structure",
				"required": [
					"ClientId",
					"Username",
					"Password"
				],
				"members": {
					"ClientId": {
						"shape": "S1b"
					},
					"SecretHash": {
						"shape": "S2d"
					},
					"Username": {
						"shape": "Sd"
					},
					"Password": {
						"shape": "Sk"
					},
					"UserAttributes": {
						"shape": "Sg"
					},
					"ValidationData": {
						"shape": "Sg"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserConfirmed": {
						"type": "boolean"
					},
					"CodeDeliveryDetails": {
						"shape": "S46"
					}
				}
			},
			"authtype": "none"
		},
		"StartUserImportJob": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"JobId"
				],
				"members": {
					"UserPoolId": {},
					"JobId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserImportJob": {
						"shape": "S2m"
					}
				}
			}
		},
		"StopUserImportJob": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"JobId"
				],
				"members": {
					"UserPoolId": {},
					"JobId": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserImportJob": {
						"shape": "S2m"
					}
				}
			}
		},
		"UpdateDeviceStatus": {
			"input": {
				"type": "structure",
				"required": [
					"AccessToken",
					"DeviceKey"
				],
				"members": {
					"AccessToken": {
						"shape": "S1k"
					},
					"DeviceKey": {},
					"DeviceRememberedStatus": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"UpdateUserAttributes": {
			"input": {
				"type": "structure",
				"required": [
					"UserAttributes"
				],
				"members": {
					"UserAttributes": {
						"shape": "Sg"
					},
					"AccessToken": {
						"shape": "S1k"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"CodeDeliveryDetailsList": {
						"type": "list",
						"member": {
							"shape": "S46"
						}
					}
				}
			},
			"authtype": "none"
		},
		"UpdateUserPool": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId"
				],
				"members": {
					"UserPoolId": {},
					"Policies": {
						"shape": "S2u"
					},
					"LambdaConfig": {
						"shape": "S2x"
					},
					"AutoVerifiedAttributes": {
						"shape": "S2y"
					},
					"SmsVerificationMessage": {},
					"EmailVerificationMessage": {},
					"EmailVerificationSubject": {},
					"SmsAuthenticationMessage": {},
					"MfaConfiguration": {},
					"DeviceConfiguration": {
						"shape": "S36"
					},
					"EmailConfiguration": {
						"shape": "S37"
					},
					"SmsConfiguration": {
						"shape": "S39"
					},
					"AdminCreateUserConfig": {
						"shape": "S3a"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			}
		},
		"UpdateUserPoolClient": {
			"input": {
				"type": "structure",
				"required": [
					"UserPoolId",
					"ClientId"
				],
				"members": {
					"UserPoolId": {},
					"ClientId": {
						"shape": "S1b"
					},
					"ClientName": {},
					"RefreshTokenValidity": {
						"type": "integer"
					},
					"ReadAttributes": {
						"shape": "S3l"
					},
					"WriteAttributes": {
						"shape": "S3l"
					},
					"ExplicitAuthFlows": {
						"shape": "S3n"
					}
				}
			},
			"output": {
				"type": "structure",
				"members": {
					"UserPoolClient": {
						"shape": "S3q"
					}
				}
			}
		},
		"VerifyUserAttribute": {
			"input": {
				"type": "structure",
				"required": [
					"AttributeName",
					"Code"
				],
				"members": {
					"AccessToken": {
						"shape": "S1k"
					},
					"AttributeName": {},
					"Code": {}
				}
			},
			"output": {
				"type": "structure",
				"members": {}
			},
			"authtype": "none"
		}
	},
	"shapes": {
		"S4": {
			"type": "structure",
			"members": {
				"Name": {},
				"AttributeDataType": {},
				"DeveloperOnlyAttribute": {
					"type": "boolean"
				},
				"Mutable": {
					"type": "boolean"
				},
				"Required": {
					"type": "boolean"
				},
				"NumberAttributeConstraints": {
					"type": "structure",
					"members": {
						"MinValue": {},
						"MaxValue": {}
					}
				},
				"StringAttributeConstraints": {
					"type": "structure",
					"members": {
						"MinLength": {},
						"MaxLength": {}
					}
				}
			}
		},
		"Sd": {
			"type": "string",
			"sensitive": true
		},
		"Sg": {
			"type": "list",
			"member": {
				"type": "structure",
				"required": [
					"Name"
				],
				"members": {
					"Name": {},
					"Value": {
						"type": "string",
						"sensitive": true
					}
				}
			}
		},
		"Sk": {
			"type": "string",
			"sensitive": true
		},
		"Sq": {
			"type": "structure",
			"members": {
				"Username": {
					"shape": "Sd"
				},
				"Attributes": {
					"shape": "Sg"
				},
				"UserCreateDate": {
					"type": "timestamp"
				},
				"UserLastModifiedDate": {
					"type": "timestamp"
				},
				"Enabled": {
					"type": "boolean"
				},
				"UserStatus": {},
				"MFAOptions": {
					"shape": "St"
				}
			}
		},
		"St": {
			"type": "list",
			"member": {
				"type": "structure",
				"members": {
					"DeliveryMedium": {},
					"AttributeName": {}
				}
			}
		},
		"Sx": {
			"type": "list",
			"member": {}
		},
		"S17": {
			"type": "structure",
			"members": {
				"DeviceKey": {},
				"DeviceAttributes": {
					"shape": "Sg"
				},
				"DeviceCreateDate": {
					"type": "timestamp"
				},
				"DeviceLastModifiedDate": {
					"type": "timestamp"
				},
				"DeviceLastAuthenticatedDate": {
					"type": "timestamp"
				}
			}
		},
		"S1b": {
			"type": "string",
			"sensitive": true
		},
		"S1d": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1e": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1i": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S1j": {
			"type": "structure",
			"members": {
				"AccessToken": {
					"shape": "S1k"
				},
				"ExpiresIn": {
					"type": "integer"
				},
				"TokenType": {},
				"RefreshToken": {
					"shape": "S1k"
				},
				"IdToken": {
					"shape": "S1k"
				},
				"NewDeviceMetadata": {
					"type": "structure",
					"members": {
						"DeviceKey": {},
						"DeviceGroupKey": {}
					}
				}
			}
		},
		"S1k": {
			"type": "string",
			"sensitive": true
		},
		"S1r": {
			"type": "list",
			"member": {
				"shape": "S17"
			}
		},
		"S1v": {
			"type": "map",
			"key": {},
			"value": {}
		},
		"S2d": {
			"type": "string",
			"sensitive": true
		},
		"S2m": {
			"type": "structure",
			"members": {
				"JobName": {},
				"JobId": {},
				"UserPoolId": {},
				"PreSignedUrl": {},
				"CreationDate": {
					"type": "timestamp"
				},
				"StartDate": {
					"type": "timestamp"
				},
				"CompletionDate": {
					"type": "timestamp"
				},
				"Status": {},
				"CloudWatchLogsRoleArn": {},
				"ImportedUsers": {
					"type": "long"
				},
				"SkippedUsers": {
					"type": "long"
				},
				"FailedUsers": {
					"type": "long"
				},
				"CompletionMessage": {}
			}
		},
		"S2u": {
			"type": "structure",
			"members": {
				"PasswordPolicy": {
					"type": "structure",
					"members": {
						"MinimumLength": {
							"type": "integer"
						},
						"RequireUppercase": {
							"type": "boolean"
						},
						"RequireLowercase": {
							"type": "boolean"
						},
						"RequireNumbers": {
							"type": "boolean"
						},
						"RequireSymbols": {
							"type": "boolean"
						}
					}
				}
			}
		},
		"S2x": {
			"type": "structure",
			"members": {
				"PreSignUp": {},
				"CustomMessage": {},
				"PostConfirmation": {},
				"PreAuthentication": {},
				"PostAuthentication": {},
				"DefineAuthChallenge": {},
				"CreateAuthChallenge": {},
				"VerifyAuthChallengeResponse": {}
			}
		},
		"S2y": {
			"type": "list",
			"member": {}
		},
		"S30": {
			"type": "list",
			"member": {}
		},
		"S36": {
			"type": "structure",
			"members": {
				"ChallengeRequiredOnNewDevice": {
					"type": "boolean"
				},
				"DeviceOnlyRememberedOnUserPrompt": {
					"type": "boolean"
				}
			}
		},
		"S37": {
			"type": "structure",
			"members": {
				"SourceArn": {},
				"ReplyToEmailAddress": {}
			}
		},
		"S39": {
			"type": "structure",
			"required": [
				"SnsCallerArn"
			],
			"members": {
				"SnsCallerArn": {},
				"ExternalId": {}
			}
		},
		"S3a": {
			"type": "structure",
			"members": {
				"AllowAdminCreateUserOnly": {
					"type": "boolean"
				},
				"UnusedAccountValidityDays": {
					"type": "integer"
				},
				"InviteMessageTemplate": {
					"type": "structure",
					"members": {
						"SMSMessage": {},
						"EmailMessage": {},
						"EmailSubject": {}
					}
				}
			}
		},
		"S3d": {
			"type": "list",
			"member": {
				"shape": "S4"
			}
		},
		"S3f": {
			"type": "structure",
			"members": {
				"Id": {},
				"Name": {},
				"Policies": {
					"shape": "S2u"
				},
				"LambdaConfig": {
					"shape": "S2x"
				},
				"Status": {},
				"LastModifiedDate": {
					"type": "timestamp"
				},
				"CreationDate": {
					"type": "timestamp"
				},
				"SchemaAttributes": {
					"shape": "S3d"
				},
				"AutoVerifiedAttributes": {
					"shape": "S2y"
				},
				"AliasAttributes": {
					"shape": "S30"
				},
				"SmsVerificationMessage": {},
				"EmailVerificationMessage": {},
				"EmailVerificationSubject": {},
				"SmsAuthenticationMessage": {},
				"MfaConfiguration": {},
				"DeviceConfiguration": {
					"shape": "S36"
				},
				"EstimatedNumberOfUsers": {
					"type": "integer"
				},
				"EmailConfiguration": {
					"shape": "S37"
				},
				"SmsConfiguration": {
					"shape": "S39"
				},
				"SmsConfigurationFailure": {},
				"EmailConfigurationFailure": {},
				"AdminCreateUserConfig": {
					"shape": "S3a"
				}
			}
		},
		"S3l": {
			"type": "list",
			"member": {}
		},
		"S3n": {
			"type": "list",
			"member": {}
		},
		"S3q": {
			"type": "structure",
			"members": {
				"UserPoolId": {},
				"ClientName": {},
				"ClientId": {
					"shape": "S1b"
				},
				"ClientSecret": {
					"type": "string",
					"sensitive": true
				},
				"LastModifiedDate": {
					"type": "timestamp"
				},
				"CreationDate": {
					"type": "timestamp"
				},
				"RefreshTokenValidity": {
					"type": "integer"
				},
				"ReadAttributes": {
					"shape": "S3l"
				},
				"WriteAttributes": {
					"shape": "S3l"
				},
				"ExplicitAuthFlows": {
					"shape": "S3n"
				}
			}
		},
		"S46": {
			"type": "structure",
			"members": {
				"Destination": {},
				"DeliveryMedium": {},
				"AttributeName": {}
			}
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/aws-sdk/apis/cognito-idp-2016-04-18.min.json
 ** module id = 1278
 ** module chunks = 0
 **/